export const frontendSentryPrivacyOptions = {
  sendDefaultPii: false,
  feedback: {
    colorScheme: "system" as const,
    enableScreenshot: false,
    isEmailRequired: true,
    triggerLabel: "Report a Bug",
    formTitle: "Report a Bug",
    messagePlaceholder: "What were you trying to do, what happened, and what did you expect instead?",
    submitButtonLabel: "Submit",
    showBranding: false,
    autoInject: false,
  },
};
